(function () {
  'use strict';
  if (!document.querySelector('.home-v2')) return;
  window.PEHomeV2._start();
})();
